import { useSelector } from 'react-redux';
import {
  AppDatePicker,
  AppInput,
  AppTextArea,
} from '@/layout/AppComponents';
import TotalEnergiesRiskRiskSelect from '../../../../../../components/form/Selects/TotalEnergiesRiskRiskSelect';
import ResponsibleSelect from '../../../../../../components/form/Selects/ResponsibleSelect';

export default function ActionPlanFields({
  values = {},
  errors = {},
  setFieldValue = () => {},
  isReadOnly = false,
}) {
  const locale = useSelector((state) => state.global?.urlData?.lang);
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <AppTextArea
            title="Descripción"
            value={values.description}
            onChange={(value) => setFieldValue('description', value)}
            error={errors.description}
            resize={!isReadOnly}
            required={!isReadOnly}
            isReadOnly={isReadOnly}
          />
        </div>
        <div className="col-lg-6">
          {isReadOnly ? (
            <AppInput
              title="Riesgo"
              value={values?.riskCode}
              isReadOnly={isReadOnly}
            />
          ) : (
            <TotalEnergiesRiskRiskSelect
              value={parseInt(values?.riskID)}
              error={errors?.riskID}
              onHandleChange={(opt) => setFieldValue('riskID', opt)}
              hasSearchBox
              isClearable
              required
            />
          )}
        </div>
        <div className="col-lg-6">
          {isReadOnly ? (
            <AppInput
              title="Responsables"
              value={values?.responsibleName || ''}
              isReadOnly={isReadOnly}
            />
          ) : (
            <ResponsibleSelect
              value={values.responsibleID}
              error={errors?.responsibleID}
              onHandleChange={(opt) => setFieldValue('responsibleID', opt)}
              apiCall="api_r_user_module_totalEnergiesRisk_control_getResponsibles"
              hasSearchBox
              isClearable
              isMulti={false}
              required
            />
          )}
        </div>
        <div className="col-lg-3">
          <AppInput
            title="Fecha de creación"
            value={values?.dateStamp}
            isReadOnly
          />
        </div>
        <div className="col-lg-3">
          {isReadOnly ? (
            <AppInput
              title="Fecha de inicio"
              value={values?.startDateStamp}
              isReadOnly={isReadOnly}
            />
          ) : (
            <AppDatePicker
              locale={locale}
              title="Fecha de inicio"
              value={values?.startDateStamp}
              error={errors?.startDateStamp}
              onChange={(opt) => {
                setFieldValue('startDateStamp', opt);
              }}
              isClearable
              showYearDropdown
              showMonthDropdown
              required
            />
          )}
        </div>
        <div className="col-lg-3">
          {isReadOnly ? (
            <AppInput
              title="Fecha de terminación"
              value={values?.endDateStamp}
              isReadOnly={isReadOnly}
            />
          ) : (
            <AppDatePicker
              locale={locale}
              title="Fecha de terminación"
              value={values?.endDateStamp}
              error={errors?.endDateStamp}
              onChange={(opt) => {
                setFieldValue('endDateStamp', opt);
              }}
              isClearable
              showYearDropdown
              showMonthDropdown
              required
            />
          )}
        </div>
        <div className="col-lg-3">
          <AppInput
            title="Fecha última modificación"
            value={values?.modificationDateStamp}
            isReadOnly
          />
        </div>
        <div className="col-lg-12">
          <AppTextArea
            title="Observaciones"
            value={values.observations}
            onChange={(value) => setFieldValue('observations', value)}
            error={errors.observations}
            resize={!isReadOnly}
            isReadOnly={isReadOnly}
          />
        </div>
      </div>
    </div>
  );
}
